import React, { useEffect } from "react";
import { IAddStandard, IStandardId } from "../../Stream.props";
import { useForm } from "react-hook-form";
import { CancelButton, FormButton } from "../../../../components/Botton";
import Loader from "../../../../components/Loader";
import useEditStream from "./useEditStream";

const EditStream: React.FC<IStandardId> = ({ standardId }) => {
  const {
    formData,
    loading,
    standard,
    languages,
    courses,
    handleChange,
    handleSubmit,
    handleCancel,
  } = useEditStream(standardId);
  const {
    register,
    handleSubmit: useFormSubmit,
    formState: { errors },
    reset,
  } = useForm<IAddStandard>();

  // Reset form with new data when formData changes
  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      reset(formData);
    }
  }, [formData, reset]);

  const fields = [
    { label: "Stream", name: "courseName", type: "text" },
    {label:"Education" , name:"standard" , type:"select" , options:standard , disabled:false},

  ] as const;

  return (
    <div className="flex flex-col items-center w-full h-screen p-8">
      <div className="bg-white shadow-md rounded-lg pt-6 pb-6 w-full ">
        <div className="border-b-2 w-[100%]">
          <h1 className="text-3xl mb-2 text-gray-700 ml-5">Edit Standard</h1>
        </div>
      
        <form onSubmit={useFormSubmit(handleSubmit)} className="space-y-6">
          <fieldset className="m-2 rounded border-opacity-60 bg-white">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 m-4">
              {fields.map((field) => (
                <div key={field.name}>
                  <label
                    className="block text-gray-700 text-base font-semibold mb-2"
                    htmlFor={field.name}
                  >
                    {field.label}:
                  </label>
                  {field.type === "select" ? (
                    <select
                      id={field.name}
                      {...register(field.name, { required: true })}
                      onChange={handleChange}
                      disabled={field.disabled}
                      value={formData[field.name]}

                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="">Select {field.label}</option>
                      {field?.options?.map((option : any) => (
                        <option key={option._id} value={option[field.name]}>
                          {option[field.name]}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      className="appearance-none border rounded w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
                      type={field.type}
                      {...register(field.name, { required: true })}
                      id={field.name}
                      value={formData[field.name]}
                      onChange={handleChange}
                    />
                  )}
                  {errors[field.name] && (
                    <p className="text-red-500 text-sm mt-1">
                      {field.label} is required.
                    </p>
                  )}
                </div>))}
            </div>
          </fieldset>
          <div className="flex justify-start mt-6 ml-10">
            <FormButton
              className="py-2 px-4 rounded mr-4"
              type="submit"
              children="Update"
            />
            <CancelButton
              className="py-2 px-4 rounded"
              onClick={handleCancel}
              children="Cancel"
              type="button"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditStream;
